/**
 *
 * Add Okta
 *
 */

import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Form } from 'components/DataEntry/Form';
import { selectSetup } from 'containers/Setup/selectors';
import { actions as setupActions } from 'containers/Setup/slice';

import { formStyles } from '../../../../../Integrations/styles';

export const AddOkta = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { onboardAccount } = useSelector(selectSetup);

  const handleReset = () => {
    navigate('/setup/accounts');
  };
  const handleSubmit = data => {
    const { url, api_token, name } = data;
    dispatch(
      setupActions.onboardAccount({
        q: {
          cloudAccountCreateRequest: {
            name,
            cloud_type: CloudProviders.Okta,
            okta: { url, api_token },
          },
        },
        onSuccess: () => navigate('/setup/accounts'),
      }),
    );
  };

  return (
    <>
      <Form
        title="Add Okta"
        iconType={CloudProviders.Okta}
        isTitleIconFilled={false}
        schema={{
          name: {
            type: 'text',
            label: 'Connector Name',
            isRequired: true,
            autoFocus: true,
          },
          url: {
            type: 'text',
            label: 'URL',
            isRequired: true,
          },
          api_token: {
            type: 'text',
            label: 'API Token',
            isRequired: true,
            htmlInputType: 'password',
            passwordShow: true,
          },
        }}
        styles={{ form: { ...formStyles.form } }}
        buttonOptions={{
          submit: { name: 'OK', isLoading: onboardAccount.isLoading },
          reset: {
            isVisible: true,
            onClick: handleReset,
          },
        }}
        handleSubmit={handleSubmit}
      />
    </>
  );
};
